import Component from '@ember/component';

/*
  attrs
  - noBorderSmDown
    - don't show the border on sm and down
    - default is true
  - slimCardBlock
    - decrease padding on the card block
    - default is false

*/
export default Component.extend({
  classNames: ['card', 'de-card'],
  classNameBindings: [
    'noBorderSmDown:de-card-no-border-sm-down',
    'slimCardBlock:de-slim-card-block',
  ],
  noBorderSmDown: true,
  slimCardBlock: false,
});
